import { ArrayUtils, engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { BaseController } from "./BaseController";
import { Paylines } from "../Paylines";
import { PaylinesSelector } from "../PaylinesSelector";
import { Symbols } from "../Symbols";
import { WinAnimator } from "../WinAnimator";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { GameManager } from "../../Managers/GameManager";
import { AppContext } from "../../../Common/AppContext";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { Tweens } from "../../Components/Effects/Tweens";
import { ImageElement } from "../../Components/Elements/Graphics/ImageElement";
import { ModuleManager } from "../../Managers/ModuleManager";
import { FreespinsView } from "../Freespins/FreespinsView";
import { StageController } from "../../Components/StageController";
import { Attributes } from "../../Utils/Attributes";
import { BaseElementAttributes } from "../../Components/Elements/Graphics/BaseElement";

type IWin = Communication.Game.IWin;

@engineComponent(ComponentTypes.DisplayObject)
export class BaseView extends ContainerElement {
    public static Background: SwitchElement;

    private _controller: BaseController;
    private _wasFinished: boolean = false;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _paylinesSelector: PaylinesSelector;

    private _symbols: Symbols;
    private _machine: Machine;
    private _noWinContainer: ContainerElement;
    private _winAnimator: WinAnimator2;

    private _paylinesBackground: ContainerElement;
    private _reels: SwitchElement;
    private _background: SwitchElement;
    private _background2: SwitchElement;
    private _logo: ImageElement;

    private _lastHighestWin: number;

    public static isDesktopChannel: boolean;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        BaseView.isDesktopChannel = false;
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            for (var key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                }

                if (this.childs[key] instanceof PaylinesSelector) {
                    this._paylinesSelector = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "Reels" && this.childs[key] instanceof SwitchElement) {
                    this._reels = this.childs[key];
                }

                if (key === "PaylinesBackground" && this.childs[key] instanceof ContainerElement) {
                    this._paylinesBackground = this.childs[key];
                }

                if (key === "Background" && this.childs[key] instanceof SwitchElement) {
                    this._background = this.childs[key];
                }

                if (key === "Background2" && this.childs[key] instanceof SwitchElement) {
                    this._background2 = this.childs[key];
                }

                if (key === "Logo" && this.childs[key] instanceof ImageElement) {
                    this._logo = this.childs[key];
                }

                if (key === "Background" && this.childs[key] instanceof SwitchElement) {
                    BaseView.Background = this.childs[key];
                }
            }

            if (this._symbols == null) {
                if (DEBUG) {
                    this.log("ERROR no symbols");
                }
            }

            if (this._machine == null) {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }

            if (this._paylines == null) {
                if (DEBUG) {
                    this.log("WARNING no paylines");
                }
            }

            if (this._winAnimator == null) {
                if (DEBUG) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    initReceived(controller: BaseController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.baseResponse != null) {
                    if (GameManager.baseResponse.initData != null && GameManager.baseResponse.initData.reels != null) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.baseResponse.initData.reels,
                            this.childs["Teasing"],
                        );
                    }

                    if (
                        GameManager.baseResponse.screen != null &&
                        GameManager.baseResponse.screen.reels != null &&
                        GameManager.baseResponse.screen.reels.length !== 0
                    ) {
                        if (this._winAnimator != null) {
                            this._winAnimator.on(
                                WinAnimator.FinishWinCalculation,
                                this.finishWinCalculation.bind(this),
                            );
                            this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                            this._winAnimator.on(
                                WinAnimator.FinishQuickWinCalculation,
                                this.finishQuickWinCalculation.bind(this),
                            );
                            this._winAnimator.initialize(this._symbols, this._paylines, this._noWinContainer);
                            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
                        }
                        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
                    } else {
                        if (DEBUG) {
                            this.log("ERROR no reels in response");
                        }
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no base reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }
        this.toggleElements(false);
        if (ModuleManager.freespinsActive()) {
            if (this._background2 != null) {
                this._background2.goToCase("NORMAL");
            }
        }
    }

    setIsDesktopChannel(isDesktopChannel: boolean = false): void {
        BaseView.isDesktopChannel = isDesktopChannel;
    }

    disableLogo(): void {
        if (this._logo != null) {
            this.removeChild(this._logo);
            this._logo = null;
        }
    }

    toggleElements(visible: boolean, long: boolean = false): void {
        if (long) {
            if (visible) {
                if (BaseView.isDesktopChannel) {
                    let tweenDuration: Array<number> = ArrayUtils.numberArray("30");
                    let tweenEase: Array<string> = ArrayUtils.stringArray("power1InOut");

                    if (this._background2 != null) {
                        this._background2.visible = true;

                        this._background2.goToCase("NORMAL");

                        Tweens.removeTweens(this._background2, "all");
                        Tweens.customTween(this._background2, {
                            tween: "position.x",
                            tweenValues: [StageController.Width, 0],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                    if (this._noWinContainer != null) {
                        this._noWinContainer.visible = true;
                        Tweens.removeTweens(this._noWinContainer, "all");
                        Tweens.customTween(this._noWinContainer, {
                            tween: "position.x",
                            tweenValues: [StageController.Width, 0],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                    if (this._paylines != null) {
                        this._paylines.visible = true;
                        Tweens.removeTweens(this._paylines, "all");
                        Tweens.customTween(this._paylines, {
                            tween: "position.x",
                            tweenValues: [StageController.Width, 0],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                    if (this._winAnimator != null) {
                        this._winAnimator.visible = true;
                        Tweens.removeTweens(this._winAnimator, "all");
                        Tweens.customTween(this._winAnimator, {
                            tween: "position.x",
                            tweenValues: [StageController.Width, 0],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                } else {
                    if (this._background2 != null) {
                        this._background2.goToCase("IN");
                        Tweens.removeTweens(this._background2, "all");
                        Tweens.alphaTween(this._background2, {
                            alphas: [0, 1],
                            tweenDuration: 15,
                        });
                    }
                    if (this._noWinContainer != null) {
                        Tweens.removeTweens(this._noWinContainer, "all");
                        Tweens.alphaTween(this._noWinContainer, {
                            alphas: [0, 1],
                            tweenDuration: 15,
                        });
                        this._noWinContainer.visible = true;
                    }
                    if (this._paylines != null) {
                        Tweens.removeTweens(this._paylines, "all");
                        Tweens.alphaTween(this._paylines, {
                            alphas: [0, 1],
                            tweenDuration: 15,
                        });
                        this._paylines.visible = true;
                    }
                    if (this._winAnimator != null) {
                        Tweens.removeTweens(this._winAnimator, "all");
                        Tweens.alphaTween(this._winAnimator, {
                            alphas: [0, 1],
                            tweenDuration: 15,
                        });
                        this._winAnimator.visible = true;
                    }
                }
            } else {
                if (BaseView.isDesktopChannel && !ModuleManager.freespinsActive()) {
                    let tweenDuration: Array<number> = ArrayUtils.numberArray("30");
                    let tweenEase: Array<string> = ArrayUtils.stringArray("power1InOut");

                    if (this._background2 != null) {
                        Tweens.removeTweens(this._background2, "all");
                        Tweens.customTween(this._background2, {
                            tween: "position.x",
                            tweenValues: [0, StageController.Width],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                    if (this._noWinContainer != null) {
                        Tweens.removeTweens(this._noWinContainer, "all");
                        Tweens.customTween(this._noWinContainer, {
                            tween: "position.x",
                            tweenValues: [0, StageController.Width],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                    if (this._paylines != null) {
                        Tweens.removeTweens(this._paylines, "all");
                        Tweens.customTween(this._paylines, {
                            tween: "position.x",
                            tweenValues: [0, StageController.Width],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                    if (this._winAnimator != null) {
                        Tweens.removeTweens(this._winAnimator, "all");
                        Tweens.customTween(this._winAnimator, {
                            tween: "position.x",
                            tweenValues: [0, StageController.Width],
                            tweenEase,
                            tweenDuration,
                            tweenDelay: [0],
                            tweenLoop: false,
                        });
                    }
                } else {
                    if (this._background2 != null) {
                        this._background2.goToCase("OUT");
                    }
                    if (this._noWinContainer != null) {
                        Tweens.removeTweens(this._noWinContainer, "all");
                        Tweens.alphaTween(this._noWinContainer, {
                            alphas: [1, 0],
                            tweenDuration: 10,
                        });
                    }
                    if (this._paylines != null) {
                        Tweens.removeTweens(this._paylines, "all");
                        Tweens.alphaTween(this._paylines, {
                            alphas: [1, 0],
                            tweenDuration: 10,
                        });
                    }
                    if (this._winAnimator != null) {
                        Tweens.removeTweens(this._winAnimator, "all");
                        Tweens.alphaTween(this._winAnimator, {
                            alphas: [1, 0],
                            tweenDuration: 10,
                        });
                    }
                }
            }
        } else {
            if (this._background2 != null) {
                if (visible) {
                    this._background2.goToCase("NORMAL");
                } else {
                    this._background2.goToCase("OUT_QUICK");
                }
            }
            if (this._noWinContainer != null) {
                this._noWinContainer.alpha = 1;
                this._noWinContainer.visible = visible;
            }
            if (this._paylines != null) {
                this._paylines.alpha = 1;
                this._paylines.visible = visible;
            }
            if (this._winAnimator != null) {
                this._winAnimator.alpha = 1;
                this._winAnimator.visible = visible;
            }
        }
    }

    initIntro(): void {
        if (BaseView.Background != null) {
            BaseView.Background.goToCase("BASE");
        }

        if (GameManager.gameResponse.totalWin > 0 || ModuleManager.freespinsEnabled()) {
            PlayList.loop("SND_BaseRecapLoop");
        } else {
            PlayList.loop("SND_BaseLoop");
        }
        this._winAnimator.showInitWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin);
        this.toggleElements(true);
    }

    collect(): void {
        this.highestWin(false);
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.loop("SND_BaseLoop");
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }
        this._winAnimator.reset(true);
    }

    spin(): void {
        this.highestWin(false);
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.loop("SND_BaseLoop");
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }
        this._machine.spinStart(this._winAnimator.reset(false));
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.baseResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        this.highestWin();
        this._wasFinished = false;
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin)) {
            PlayList.stop("SND_BaseLoop");
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    finishWinCalculation(): void {
        this._wasFinished = true;
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        if (!DataManager.Autoplay || ModuleManager.freespinsEnabled()) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecapLoop");
        }
        this._controller.allWinsFinished();
    }

    resetWinAnimator(): void {
        this._winAnimator.reset(true);
    }

    intro(long: boolean = false): void {
        if (BaseView.Background != null) {
            BaseView.Background.goToCase("BASE");
        }
        PlayList.loop("SND_BaseLoop");
        if (long) {
            if (FreespinsView.Transition != null) {
                this.addChild(FreespinsView.Transition);
            }
            this._introDelay.start(30);
            this.toggleElements(true, false);
        } else {
            this.toggleElements(true, true);
            this._introDelay.start(30);
        }
    }

    introFinished(): void {
        this._introDelay.stop();

        StageController.baseStage = true;

        if (GameManager.gameResponse.totalWin > 0) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecapLoop");
        } else {
            PlayList.stop("SND_BaseRecapLoop");
            PlayList.loop("SND_BaseLoop");
        }
        this._controller.introFinished();
    }

    outro(isDesktopChannel: boolean = false): void {
        StageController.baseStage = true;

        PlayList.stop("SND_BaseLoop");
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.stop("SND_FSWinLoop");

        this.highestWin(false);
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        let wasFinished: boolean = this._wasFinished;
        let inHighWins: boolean = this._winAnimator.reset(true);

        if (ModuleManager.freespinsActive()) {
            PlayList.play("SND_FSTrans");
            if (FreespinsView.Transition != null) {
                this.addChild(FreespinsView.Transition);
                FreespinsView.Transition.goToCase("IN");
            }
            this._outroDelay.start(15);
        } else {
            PlayList.stop("SND_BaseLoop");
            if (wasFinished) {
                this.outroFinished();
            } else {
                if (inHighWins) {
                    this._outroDelay.start(60);
                } else {
                    this._outroDelay.start(30);
                }
            }
        }
    }

    outroFinished(): void {
        this.toggleElements(false, true);
        if (ModuleManager.freespinsActive()) {
            if (this._background2 != null) {
                this._background2.goToCase("NORMAL");
            }
        }
        this._controller.outroFinished();
    }

    selectPayline(): void {
        if (this._paylinesSelector != null) {
            this._paylinesSelector.select();
        }
    }

    private highestWin(win: boolean = true): void {
        if (!win) {
            if (this._reels != null) {
                this._reels.goToCase("NORMAL");
            }
        }

        if (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.wins != null &&
            GameManager.baseResponse.wins.length > 0
        ) {
            if (win) {
                if (this._reels != null) {
                    this._reels.goToCase("WIN");
                }
            }
            let highestWin: IWin = null;

            for (let i: number = 0; i < GameManager.baseResponse.wins.length; i++) {
                if (highestWin == null) {
                    highestWin = GameManager.baseResponse.wins[i];
                } else {
                    let nextWin: IWin = GameManager.baseResponse.wins[i];
                    if (nextWin.amount > highestWin.amount) {
                        highestWin = nextWin;
                    }
                }
            }

            if (highestWin != null && highestWin.payoutId != null) {
                if (this._background != null) {
                    if (win) {
                        this._background.goToCase("WIN_" + highestWin.payoutId);
                        this._lastHighestWin = highestWin.payoutId;
                    } else {
                        this._background.goToCase("WIN_" + highestWin.payoutId + "_END");
                        this._lastHighestWin = null;
                    }
                }
            }
        } else {
            if (this._background != null) {
                if (this._lastHighestWin != null) {
                    this._background.goToCase("WIN_" + this._lastHighestWin + "_END");
                    this._lastHighestWin = null;
                }
            }
        }
    }

    disableBase(): void {
        this._winAnimator.resetTimer();
    }

    /**
     * Toggle all sounds used in base game (background, effects, .etc)
     * @param enable
     */
    toggleSounds(enable: boolean): void {
        if (enable) {
            PlayList.loop("SND_BaseLoop");
        } else {
            PlayList.stop("SND_BaseLoop");
            PlayList.stop("SND_BaseRecapLoop");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseView.ts
 **/